jQuery(document).ready(function ($) {

    function preloadImage(url) {
        if (url) {
            var img = new Image();
            img.src = url;

            img.onload = function() {
                console.log('Image loaded: ' + url);
            };
            img.onerror = function() {
                console.log('Image failed to load: ' + url);
            };
        }
    }

    $('.comparisonItem__color').each(function(){
        var imgUrl = $(this).attr('data-variant-image');
        preloadImage(imgUrl);
    });

    $('.comparisonItem__color').on('click', function () {
        var origin = $(this).closest('.comparisonItem');
        var variantImage = $(this).attr('data-variant-image');
        origin.find('.comparisonItem__image').attr('src', variantImage);
    });
});